import React from 'react';
import { ViewerImage } from './types';
import ImageView from '@staltz/react-native-image-viewing';
import Stack from '../Stack';
import Text from '../Text';

export type NativeImageViewOwnProps = {
    images: ViewerImage[];
    imageIndex: number;
    isOpen: boolean;
    onClose: () => void;
};

export type NativeImageViewProps = NativeImageViewOwnProps;

const NativeImageView: React.FC<NativeImageViewProps> = ({ images, imageIndex, isOpen, onClose }) => {
    return (
        <ImageView
            images={images}
            imageIndex={imageIndex}
            visible={isOpen}
            onRequestClose={onClose}
            FooterComponent={({ imageIndex }) => {
                const description = images[imageIndex].description;
                if (!description) return null;

                return (
                    <Stack horizontal align={'center'} justify={'center'} padding={2}>
                        <Text variant="subtitle-1" color="White">
                            {description}
                        </Text>
                    </Stack>
                );
            }}
        />
    );
};

export default React.memo(NativeImageView);
